import { gql } from '@apollo/client';
import { REPORT } from '../fragments';

export const DELETE_REPORT = gql`
  mutation deleteReport($id: ID!) {
    report: deleteReport(id: $id) {
      ...report
    }
  }
  ${REPORT}
`;
